import { useState } from 'react'

export const useCategoriesManager = (
  categories: string[],
  onCategoriesChange: (categories: string[]) => void
) => {
  const [newCategory, setNewCategory] = useState<string>('')

  const handleAddCategory = () => {
    if (newCategory.trim() && !categories.includes(newCategory.trim())) {
      const updatedCategories = [...categories, newCategory.trim()]
      onCategoriesChange(updatedCategories)
      setNewCategory('')
    }
  }

  const handleRemoveCategory = (category: string) => {
    const updatedCategories = categories.filter(c => c !== category)
    onCategoriesChange(updatedCategories)
  }

  return {
    newCategory,
    setNewCategory,
    handleAddCategory,
    handleRemoveCategory
  }
}
